import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import UserSessionsAdminList from './components/UserSessionsAdminList';

const UserSessionsAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="User admin tabs">
        <Tab label="List Users" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UserSessionsAdminList />}
      </Box>
    </Box>
  );
};

export default UserSessionsAdminPage;